import React, { useState, useEffect } from 'react'
import { types } from '../types.js'
import './campaignheader.css'
import DOMPurify from 'dompurify'
import { isCms, isLocal } from '../../utility/index.js'

export const CampaignHeader = ({ page, component }) => {
  const [_data, setData] = useState({
    links: '',
  })

  useEffect(() => {
    const _models = component?.getModels() || {}
    const { document: _documentRef } = _models
    const _document = _documentRef && page.getContent(_documentRef)

    if (_document) {
      const data = _document.getData()

      setData({
        links: data.linkList.links,
      })
    }
  }, [page, component])

  const links = _data.links

  const renderLinkList = () => {
    let linkObj = []

    if (links) {
      for (var i = 0; i < links.length; i++) {
        linkObj[i] = links[i]
      }
    }

    return (
      <ul>
        {linkObj
          .sort((a, b) => (a.asButton > b.asButton ? 1 : -1))
          .map((link, i) =>
            !link.asButton ? (
              <li key={i} className="u-inlineBlock u-marginRight1gu">
                <a
                  className="u-marginLeft1gu"
                  href={DOMPurify.sanitize(link.link[0].string)}
                  data-analytics="campaign-header-link"
                >
                  {link.text}
                </a>
              </li>
            ) : (
              <li
                key={i}
                className="u-inlineBlock u-marginRight1gu Button--link"
              >
                <a
                  className="Button Button--primary u-bgColorDuff u-textColorBrand u-marginLeft3gu"
                  href={DOMPurify.sanitize(link.link[0].string)}
                  data-analytics="campaign-header-button"
                >
                  {link.icon && (
                    <i
                      className="Icon--material u-marginRight1gu u-textSizeMsrp2"
                      aria-hidden="true"
                    >
                      {link.icon}
                    </i>
                  )}
                  {link.text}
                </a>
              </li>
            )
          )}
      </ul>
    )
  }

  const logoImg = `${
    isLocal() || isCms() ? '/site' : ''
  }/webfiles/latest/assets/cti/images/brand_logo.svg`

  return (
    <>
      <div className="CampaignHeader">
        <div
          className="CampaignHeader-Container u-sizeFull u-bgColorWhite u-posFixed"
          data-analytics="campaign-header"
        >
          <div
            className="u-lg-flex u-flexAlignItemsCenter u-sizeConstrained u-flexJustifyBetween u-sm-paddingTop2gu u-md-paddingTop2gu u-sm-paddingBottom2gu u-md-paddingBottom2gu topNav-container u-paddingTop4gu u-paddingBottom4gu"
            aria-label="Campaign Navigation"
          >
            <h1 className="u-sm-marginRight0 u-marginRight6gu site-logo">
              <img src={logoImg} alt="" height="55" width="214" />
            </h1>
            <div className="u-posRelative">{renderLinkList()}</div>
          </div>
        </div>
      </div>
    </>
  )
}

CampaignHeader.propTypes = {
  ...types,
}
